export default {
    channelConstants: {
        channels: {
            Web: "Web",
            MobileWeb: "MobileWeb",
        },
        default: "Web",
    },
};



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/settings/channel-constants.ts